import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';
import { useAuthStore } from '../store/auth.ts';

export const api: AxiosInstance = axios.create({ baseURL: '/api', withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = useAuthStore.getState().accessToken;
  if (t && cfg.headers) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing: Promise<void> | null = null;
api.interceptors.response.use(
  (r) => r,
  async (err: { response?: { status?: number }; config?: InternalAxiosRequestConfig & { _retry?: boolean } }) => {
    const status = err.response?.status;
    const original = err.config;
    if (status === 401 && original && !original._retry) {
      original._retry = true;
      refreshing ??= useAuthStore.getState().refresh().finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(original);
      } catch {
        useAuthStore.getState().logout();
        window.location.href = '/login';
      }
    }
    throw err;
  },
);
